import { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../redux/ReportAction";
import { Modal } from "../../common/Modal1";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { formatInTimeZone } from "date-fns-tz";

export const MemberSummaryDetail = ({
  selMemberId,
  selMemberName,
  fromDate,
  toDate,
  memberReportDetailsVisible,
  onClose,
}) => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const reportState = useSelector(({ report }) => report, shallowEqual);
  const timeZone = "Asia/Kuala_Lumpur";

  useEffect(() => {
    if (memberReportDetailsVisible && selMemberId) {
      const queryParams = {
        action: "membergamesummary_detail",
        selmemberid: selMemberId,
        fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
        todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
      };
      dispatch(actions.fetchMemberSummaryDetail(queryParams));
    }
  }, [selMemberId, memberReportDetailsVisible]);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="agentDownlineMemberReportModal"
        title={intl.formatMessage({ id: "memberDetails" })}
        dismissBtnRef={dismissBtnRef}
        isVisible={memberReportDetailsVisible}
        onClose={onClose}
        modalSize="modal-xl"
      >
        <SweetAlert2
          customClass="custom-swal"
          onResolve={() => {
            setSwalProps({});
          }}
          {...swalProps}
        />
        <span className="mx-3">{selMemberName}</span>

        <div className="mobile-fontSize px-3 text-danger">
          <div>{intl.formatMessage({ id: "totalInRemark" })}</div>
          <div>{intl.formatMessage({ id: "totalOutRemark" })}</div>
        </div>
        <div className="d-flex justify-content-end px-3">
          <div>
            (
            {intl.formatMessage({ id: "refund" }) +
              " : " +
              reportState.memberSummaryDetail?.totalrefund}
            )
          </div>
        </div>
        <div className="member-div d-flex" style={{ margin: "10px auto" }}>
          <div className="member-container">
            <div className="table-responsive px-2">
              <table className="member-table">
                <thead className="member-header1">
                  <tr className="member-row1">
                    <th className="member-cell hide-on-mobile">
                      {intl.formatMessage({ id: "no" })}
                    </th>
                    <th className="member-cell text-start text-nowrap">
                      {intl.formatMessage({ id: "companyName" })}
                    </th>
                    <th className="member-cell text-end text-nowrap">
                      {intl.formatMessage({ id: "promotion" })}
                    </th>
                    <th className="member-cell text-end text-nowrap">
                      {intl.formatMessage({ id: "gameIn" })}
                    </th>
                    <th className="member-cell text-end text-nowrap">
                      {intl.formatMessage({ id: "gameOut" })}
                    </th>
                    <th className="member-cell text-end text-nowrap">
                      {intl.formatMessage({ id: "gameProfit" })}
                    </th>
                    <th className="member-cell text-end text-nowrap">
                      {intl.formatMessage({ id: "progressiveBet" })}
                    </th>
                    <th className="member-cell text-end text-nowrap">
                      {intl.formatMessage({ id: "progressiveWin" })}
                    </th>
                  </tr>
                </thead>
                <tbody className="member-body">
                  {reportState.memberSummaryDetail &&
                    reportState.memberSummaryDetail.memberGameSummary_Details &&
                    reportState.memberSummaryDetail.memberGameSummary_Details
                      .length > 0 &&
                    reportState.memberSummaryDetail.memberGameSummary_Details.map(
                      (report, index) => (
                        <tr key={index} className="member-row1">
                          <td className="member-cell hide-on-mobile">
                            {index + 1}
                          </td>
                          <td className="member-cell text-start">
                            {report.companyname}
                          </td>
                          <td className="member-cell text-end">
                            {report.totalpromoin}
                          </td>
                          <td className="member-cell text-end">
                            {report.totalgamein}
                          </td>
                          <td className="member-cell text-end">
                            {report.totalgameout}
                          </td>
                          <td className="member-cell text-end">
                            {report.totalgameprofit}
                          </td>
                          <td className="member-cell text-end">
                            {report.totalprogressivebet}
                          </td>
                          <td className="member-cell text-end">
                            {report.totalprogressivewin}
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
                <tfoot>
                  {reportState.memberSummaryDetail && (
                    <tr className="member-row1">
                      <td className="member-cell hide-on-mobile"></td>
                      <td className="member-cell text-end">
                        {intl.formatMessage({ id: "total" }) + " : "}
                      </td>
                      <td className="member-cell text-end">
                        {reportState.memberSummaryDetail.totalpromoin}
                      </td>
                      <td className="member-cell text-end">
                        {reportState.memberSummaryDetail.totalgamein}
                      </td>
                      <td className="member-cell text-end">
                        {reportState.memberSummaryDetail.totalgameout}
                      </td>
                      <td className="member-cell text-end">
                        {reportState.memberSummaryDetail.totalgameprofit}
                      </td>
                      <td className="member-cell text-end">
                        {reportState.memberSummaryDetail.totalprogressivebet}
                      </td>
                      <td className="member-cell text-end">
                        {reportState.memberSummaryDetail.totalprogressivewin}
                      </td>
                    </tr>
                  )}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
